<template>
  <div class="card_details">
    <div class="card_details-info">
      <div class="card-details">
        <dl class="card-details_item">
          <dt class="card-details_title">{{ $t('Код карты:') }}</dt>
          <dd class="card-details_value">
            <span
              class="card-details_number"
              @copy.prevent="copyCodeToClipboard"
              v-text="formattedCardCode"
            />
          </dd>
        </dl>
        <dl class="card-details_item">
          <dt class="card-details_title">{{$t('Текущая игра:')}}</dt>
          <dd class="card-details_value">
            <span class="card-details_game">
              <span
                class="game-name"
                :class="'game-name__' + card.currentGame"
                v-text="cardCurrentGameName"
              />
            </span>
          </dd>
        </dl>
      </div>
    </div>
    <div class="card_details-action">
      <ul class="card-details">
        <li class="card-details_item">
          <button class="pseudolink" @click="copyCodeToClipboard" v-if="!codeCopied">
            <span class="pseudolink_mob">{{ $t('Скопировать') }}</span>
            <span class="pseudolink_tablet">{{ $t('Скопировать код карты') }}</span>
          </button>
          <span class="card-details_status" v-else>
            <span class="card-details_text-mob">{{ $t('Скопировано') }}</span>
            <span class="card-details_text-tablet">{{ $t('Код скопирован в буфер обмена') }}</span>
          </span>
        </li>
        <li
          class="card-details_item"
          v-if="!isAlfaBy"
        >
          <button class="pseudolink" @click="initGameChange">
            <span class="pseudolink_mob">{{ $t('Сменить игру') }}</span>
            <span class="pseudolink_tablet">{{ $t('Сменить привязку игры') }}</span>
          </button>
        </li>
        <li class="card-details_item">
          <button class="pseudolink" @click="initDesignChange">
            <span class="pseudolink_mob">{{ $t('Другие виртуальные обложки') }}</span>
            <span class="pseudolink_tablet">{{ $t('Другие виртуальные обложки') }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { GAME_NAMES, PARTNERS } from '@/constants'
import { writeText as copyTextToClipboard } from 'clipboard-polyfill'

@Component
class CardDetails extends Vue {
  @Prop(Object) card

  codeCopied = false

  /**
   * Card code splitted with ' - '
   * @type {string}
   */
  get formattedCardCode () {
    return this.card.cardCode.match(/.{1,4}/g).join(' - ')
  }

  /**
   * Human readable card current game
   * @type {string}
   */
  get cardCurrentGameName () {
    return this.$t(GAME_NAMES[this.card.currentGame])
  }

  get isAlfaBy () {
    return this.card.partner === PARTNERS.ALFABANK_BY || this.card.partner === PARTNERS.ALFA_BY
  }

  /**
   * Copy card code to clipboard
   */
  copyCodeToClipboard () {
    copyTextToClipboard(this.card.cardCode)
    this.$analytics.trackCopyCardCode({ screenId: this.$route.name, game: this.card.currentGame })

    this.codeCopied = true
    setTimeout(() => { this.codeCopied = false }, 5000)
  }

  /**
   * @emits <game-change>
   */
  initGameChange () {
    this.$emit('game-change', this.card)
    this.$analytics.trackChangeGameMyCardsPage({ screenId: this.$route.name, game: this.card.currentGame })
  }

  /**
   * @emits <design-change>
   */
  initDesignChange () {
    this.$emit('design-change', this.card)
  }
}

export default CardDetails
</script>

<style lang="scss" src="./styles/card-details.scss"></style>
